import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ErrorLog {
  id: string;
  created_at: string;
  error_message: string;
  error_details: string | null;
  error_stack: string | null;
  user_id: string | null;
  user_email: string | null;
  page_url: string | null;
  component: string | null;
  action: string | null;
  metadata: Record<string, unknown> | null;
}

export function useErrorLogs() {
  return useQuery({
    queryKey: ["error-logs"],
    queryFn: async () => {
      // Use type assertion for newly created table
      const { data, error } = await (supabase as any)
        .from("error_logs")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(100);

      if (error) throw error;
      return data as ErrorLog[];
    },
  });
}

export function useDeleteErrorLog() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (logId: string) => {
      const { error } = await (supabase as any)
        .from("error_logs")
        .delete()
        .eq("id", logId);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["error-logs"] });
    },
  });
}

export function useClearErrorLogs() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { error } = await (supabase as any)
        .from("error_logs")
        .delete()
        .neq("id", "00000000-0000-0000-0000-000000000000"); // Delete all

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["error-logs"] });
    },
  });
}
